import {useQuery} from 'react-query';

import getSaleAgentsList from '.';

const useGetSaleAgentsList = (store_guid: string) => {
  const {data, isLoading, refetch} = useQuery(
    ['get-sale-agent-list', store_guid],
    getSaleAgentsList,
  );

  return {saleAgentList: data, isLoading, refetchGetSaleAgentList: refetch};
};

export default useGetSaleAgentsList;
